import React, { FC } from "react";
import { Store } from "../../entities/interfaces/stores";
import { Order } from "../../entities/interfaces/order";
import dayjs from "dayjs";
import { calculateDiscountAmtFromBill } from "../../utils/helpers";
import { flattenOrderItems } from "../../utils/orderhelpers";

type Props = {
  store: Store;
  order: Order;
};

const BillLayout: FC<Props> = ({ store, order }) => {
  const { bill } = order;

  const renderItems = () => {
    return flattenOrderItems(order.items).map((item, i) => (
      <tr key={i}>
        <td className="py-1">{item.name}</td>
        <td className="py-1">{item.quantity}</td>
        <td className="py-1">{item.rate}</td>
        <td className="py-1">{item.amount}</td>
      </tr>
    ));
  };

  return (
    <div className="w-[400px] font-mono text-baseP leading-5 p-4">
      <div className="text-center">
        <div className="font-bold text-lg">{store.name}</div>
        <div>
          {store.address} {store.city} - {store.postalCode}. Mob:{" "}
          {store.contactNumber}
        </div>
      </div>

      <hr className="my-2 border-t border-dashed border-black" />

      <div className="space-y-1">
        <div className="flex justify-between">
          <span>Bill No:</span>
          <span className="font-bold">{bill.invoidId}</span>
        </div>
        <div className="flex justify-between">
          <span>Date:</span>
          <span className="font-bold">
            {dayjs(bill.billingDate).format("DD/MM/YYYY")}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Customer Name:</span>
          <span className="font-bold">{order.customer.name}</span>
        </div>
        <div className="flex justify-between">
          <span>Mobile No:</span>
          <span className="font-bold">{order.customer.phone}</span>
        </div>
      </div>

      <hr className="my-2 border-t border-dashed border-black" />

      <table className="w-full text-left">
        <thead>
          <tr className="border-b border-black">
            <th className="pb-1">Description</th>
            <th className="pb-1">Qty</th>
            <th className="pb-1">Rate</th>
            <th className="pb-1">Amount</th>
          </tr>
        </thead>
        <tbody>{renderItems()}</tbody>
      </table>

      <hr className="my-2 border-t border-dashed border-black" />

      <div className="space-y-1">
        <div className="flex justify-between">
          <span>Gross Total:</span>
          <span>₹{bill.subtotal}</span>
        </div>

        {bill.discount.length > 0 && (
          <div className="flex justify-between">
            <span>Membership Discount:</span>
            <span>- ₹{calculateDiscountAmtFromBill(bill.discount)}</span>
          </div>
        )}

        <div className="flex justify-between">
          <span>GST (18%):</span>
          <span>₹{bill.tax}</span>
        </div>

        <div className="flex justify-between font-bold">
          <span>Net Amount:</span>
          <span>₹{bill.totalAmount}</span>
        </div>
      </div>

      <div className="text-center mt-4">
        <p>Thanks for visiting our salon</p>
        <p>Visit again!</p>
      </div>
    </div>
  );
};

export default BillLayout;
